/** Action card constants (CLAUDE.md rule 5): form limits, contract tokens and download settings. */

/** `contact_rule` of the lead form: at least one of email / mobile must be filled. */
export const CONTACT_RULE_EMAIL_OR_PHONE = "email_or_phone";

/** Reserved form key of the privacy-notice checkbox (never a server field name). */
export const CONSENT_KEY = "__consent";
export const EMAIL_FIELD = "email";
export const MOBILE_FIELD = "mobile";
/** Server field name flagged when no time was picked (`validation_error` → `details.fields`). */
export const SLOT_FIELD = "slot_id";

export const FIELD_MAX_CHARS = 120;
export const TEXTAREA_MAX_CHARS = 500;
export const TEXTAREA_ROWS = 3;

export const ICS_MIME_TYPE = "text/calendar;charset=utf-8";
/** The object URL stays valid this long after the click (in-app browsers read it late). */
export const ICS_REVOKE_DELAY_MS = 1000;

/** `ResultCard.state` values. */
export const RESULT_STATE = { sent: "sent", requested: "requested", confirmed: "confirmed", failed: "failed" } as const;

export const NO_FIELDS: readonly string[] = [];

/** Error code of a request already completed (other idempotency key) or still in progress. */
export const CONFLICT_ERROR_CODE = "conflict";

/** Error `code`s that offer a "Try again" button (the card stays open). */
export const RETRYABLE_FAILURES: ReadonlySet<string> = new Set(["service_unavailable", "network", "timeout", "unknown"]);

/** Keys that move the roving focus inside a chip group. */
export const ROVING_NEXT_KEYS: ReadonlySet<string> = new Set(["ArrowRight", "ArrowDown"]);
export const ROVING_PREVIOUS_KEYS: ReadonlySet<string> = new Set(["ArrowLeft", "ArrowUp"]);
